import { forEach, get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';

/*************************************************************/

/**
 * @type {class}
 * @desc FileUpload service uploads a file with multipart form-data body.
 * source => https://github.com/axios/axios/tree/master/examples/upload
 *
 * @example
 * import { FileUploadService } from 'services/fileUpload';
 *
 * // create service instance and send/cancel request
 * const fileUploadService = new FileUploadService();
 * const result = await fileUploadService.upload(); // upload a file
 * fileUploadService.cancel(); // cancel an active request
 */
export class FileUploadService extends HttpService {

    // constructor
    constructor( ) {
        super();

        // file upload service url
        this.url = get( CONFIG, 'endpoints.globalServices.fileUpload' );
    }

    async uploadMultiple( { params = {}, files = [] } ) {
        log.debug( 'FileUploadService.uploadMultiple()' );

        // create form data
        const formData = new FormData();

        files.map( ( file ) => {
            formData.append( file.name, file );
        } );

        /*----------------*/

        return await this.post( {
            host: CONFIG.host,
            path: this.url,
            params,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        } );
    }

    // upload file using `POST` method
    async upload( { params = {}, data = {}, file = null, url } ) {
        log.debug( 'FileUploadService.upload()' );

        // create form data
        const formData = new FormData();

        // append data fields to the `formData`
        forEach( data, ( val, key ) => {
            formData.append( key, val );
        } );

        // append file to the `formData`
        formData.append( 'file', file );

        // append file name
        formData.append( 'name', file.name );

        /*----------------*/

        return await this.post( {
            host: CONFIG.host,
            path: url,
            params,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        } );
    }
}
